const pad = (num) => (num < 10 ? '0' : '') + num;

export function toQalendarDateString(date) {
  return (
    date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    ' ' + pad(date.getHours()) +
    ':' + pad(date.getMinutes())
  );
}

export function toIsoString(date) {
  return (
    date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    'T' + pad(date.getHours()) +
    ':' + pad(date.getMinutes()) +
    ':' + pad(date.getSeconds())
  );
}

/** From ISO string (YYYY-MM-DDTHH:mm:ss or YYYY-MM-DD) get date part YYYY-MM-DD */
export function isoToDateString(iso) {
  if (!iso) return '';
  return iso.slice(0, 10);
}

/** From ISO string get time part HH:mm */
export function isoToTimeString(iso) {
  if (!iso || iso.length < 16) return '';
  return iso.slice(11, 16);
}

const MAX_RECURRENCE_OCCURRENCES = 52;

/**
 * Compute occurrence date ranges for recurring appointments.
 * @param {number} startMs - First occurrence start (ms)
 * @param {number} endMs - First occurrence end (ms)
 * @param {'weekly'|'biweekly'|'monthly'} frequency
 * @param {{ type: 'until'|'count', untilDateMs?: number, count?: number }} endCondition
 * @returns {{ dateMs: number, endDateMs: number }[]}
 */
export function computeRecurrenceOccurrences(startMs, endMs, frequency, endCondition) {
  const durationMs = (endMs || startMs) - startMs;
  const occurrences = [];
  let currentStart = startMs;
  const countLimit = endCondition.type === 'count' ? Math.min(endCondition.count, MAX_RECURRENCE_OCCURRENCES) : MAX_RECURRENCE_OCCURRENCES;
  const untilMs = endCondition.type === 'until' && endCondition.untilDateMs ? endCondition.untilDateMs : null;

  while (occurrences.length < countLimit) {
    const currentEnd = currentStart + durationMs;
    if (untilMs != null && currentStart > untilMs) break;
    occurrences.push({ dateMs: currentStart, endDateMs: currentEnd });

    const d = new Date(currentStart);
    if (frequency === 'weekly') {
      d.setDate(d.getDate() + 7);
    } else if (frequency === 'biweekly') {
      d.setDate(d.getDate() + 14);
    } else if (frequency === 'monthly') {
      d.setMonth(d.getMonth() + 1);
    }
    currentStart = d.getTime();
  }

  return occurrences;
}
